import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, AfterContentChecked, ElementRef } from '@angular/core';

@Component({
  selector: 'app-pick-list-button',
  templateUrl: './pick-list-button.component.html',
  styleUrls: ['./pick-list-button.component.css']
})
export class PickListButtonComponent implements OnInit, AfterContentChecked {
  @Input() elementsOptions: any[];
  @Input() elementsSelected: number[];

  @Input() titlePickList: string;
  @Input() titleMultiLeft: string;
  @Input() titleMultiRight: string;

  @Output() elementsSelectedChange = new EventEmitter<number[]>();

  @Output() saveElementsEvent = new EventEmitter<number[]>();

  elementsOptionsShow: { elements: any[], showMore: boolean } = { elements: [], showMore: false };
  elementsOptionsFiltered: any[];

  elementsRight: any[] = [];
  elementsRightShow: { elements: any[], showMore: boolean } = { elements: [], showMore: false };
  elementsRightFiltered: any[];

  elementsOptionSelected: any[];
  elementsRightSelected: any[];

  numberElements = 100;

  showNumberOptionElements = this.numberElements;
  showNumberRightElements = this.numberElements;

  isChargingOptions = false;
  isChargingRight = false;

  searchOptionText: string;
  searchRightText: string;

  constructor(private cdRef: ChangeDetectorRef,
  private element: ElementRef) { }

  ngOnInit() {
    this.createElementsRight();
  }

  ngAfterContentChecked(): void {
    if (this.element.nativeElement.querySelector('.is-rendering')) {
      setTimeout(() => {
        this.isChargingOptions = false;
        this.isChargingRight = false;
      }, (500));
     }
  }

  private createElementsRight(): any {
    this.elementsRight = this.elementsOptions.filter(option => this.elementsSelected.some(elementId => option.Id == elementId));
    this.elementsOptions = this.elementsOptions.filter(option => !this.elementsSelected.some(elementId => option.Id == elementId));
    this.elementsOptionsFiltered = this.elementsOptions;
    this.elementsRightFiltered = this.elementsRight;
    this.setElementsToShow(this.elementsOptions, this.elementsRight);
  }

  private setElementsToShow(elementsOptions, elementsRight) {
    this.elementsRightShow.elements = [...elementsRight.slice(0, this.showNumberRightElements)];
    this.elementsRightShow.showMore = elementsRight.length > this.showNumberRightElements;
    this.elementsOptionsShow.elements = [...elementsOptions.slice(0, this.showNumberOptionElements)];
    this.elementsOptionsShow.showMore = elementsOptions.length > this.showNumberOptionElements;
   }

  allRight() {
    this.setInitialNumberElementsShowed();

    this.elementsRight = [...this.elementsRight, ...this.elementsOptions];
    this.elementsOptions = [];

    this.flushElements();
  }

  right() {
    this.setInitialNumberElementsShowed();
    const elementsInLeft = this.elementsOptions.filter(elementLeft =>
                                  this.elementsOptionSelected.some(idElementLeftSelected => idElementLeftSelected == elementLeft.Id));
    this.elementsRight = [...this.elementsRight, ...elementsInLeft];
    this.elementsOptions = this.elementsOptions.filter(option => !this.elementsOptionSelected.some(elementId => option.Id == elementId));
    this.elementsOptionSelected = [];

    this.flushElements();
  }
  setInitialNumberElementsShowed() {
    this.showNumberOptionElements = this.numberElements;
    this.showNumberRightElements = this.numberElements;
  }

  left() {
    this.setInitialNumberElementsShowed();

    const elementsInRight = this.elementsRight.filter(elementRight =>
                                        this.elementsRightSelected.some(idElementRightSelected => idElementRightSelected == elementRight.Id));
    this.elementsOptions = [...this.elementsOptions, ...elementsInRight];
    this.elementsRight = this.elementsRight.filter(option => !this.elementsRightSelected.some(elementId => option.Id == elementId));
    this.elementsRightSelected = [];

    this.flushElements();
  }

  allLeft() {
    this.setInitialNumberElementsShowed();

    this.elementsOptions = [...this.elementsOptions, ...this.elementsRight];
    this.elementsRight = [];
    this.flushElements();
  }

  private flushElements() {
    this.searchRightText = '';
    this.searchOptionText = '';
    this.elementsRightFiltered = this.elementsRight;
    this.elementsOptionsFiltered = this.elementsOptions;

    const idsSelected = this.elementsRight.map(elementRight => elementRight.Id);
    this.elementsSelectedChange.emit(idsSelected);
    this.setElementsToShow(this.elementsOptions, this.elementsRight);
  }

  saveElements() {
    const idsSelected: number[] = this.elementsRight.map(elementRight => elementRight.Id);
    this.saveElementsEvent.emit(idsSelected);
  }

  changeElementsOptions(values) {
    if (this.elementsOptionSelected.some(elementSelected => elementSelected == -1)) {
      this.isChargingOptions = true;
      setTimeout(() => {
        this.elementsOptionSelected = this.elementsOptionSelected.filter(elementsSelected => elementsSelected != -1);
        this.showNumberOptionElements = this.elementsOptionsFiltered.length + this.elementsRightFiltered.length;
        this.setElementsToShow(this.elementsOptionsFiltered, this.elementsRightFiltered);
      }, (500));
    }
  }

  changeElementsRight(values) {
    if (this.elementsRightSelected.some(elementSelected => elementSelected == -1)) {
      this.isChargingRight = true;
      setTimeout(() => {
        this.elementsRightSelected = this.elementsRightSelected.filter(elementsSelected => elementsSelected != -1);
        this.showNumberRightElements = this.elementsOptionsFiltered.length + this.elementsRightFiltered.length;
        this.setElementsToShow(this.elementsOptionsFiltered, this.elementsRight);
      }, (500));
    }
  }

  filterOptionsChange(text) {
    this.setInitialNumberElementsShowed();
    if (!text || text == '') {
      this.setElementsToShow(this.elementsOptions, this.elementsRightFiltered);
      return;
     }
    this.elementsOptionsFiltered = this.elementsOptions.filter(element => element.NOMBRE.indexOf(text) != -1);
    this.setElementsToShow(this.elementsOptionsFiltered, this.elementsRight);
  }

  filterRightChange(text) {
    this.setInitialNumberElementsShowed();
    if (!text || text == '') {
      this.setElementsToShow(this.elementsOptionsFiltered, this.elementsRight);
      return;
    }
    this.elementsRightFiltered = this.elementsRight.filter(element => element.NOMBRE.indexOf(text) != -1);
    this.setElementsToShow(this.elementsOptionsFiltered, this.elementsRightFiltered);
  }
}
